export default __webpack_public_path__ + "static/media/alt_ey_logo.496b7a0e.png";